module.exports = __webpack_public_path__ + "static/media/reading.19a37053.svg";